import { TitulacaoCoordenadorCursoCertificacao } from 'src/tipos'

export const OPCOES_TITULACAO_COORDENADOR = [
  {
    id:
      TitulacaoCoordenadorCursoCertificacao[
        TitulacaoCoordenadorCursoCertificacao.Especializacao
      ],
    texto: 'Especialização'
  },
  {
    id:
      TitulacaoCoordenadorCursoCertificacao[
        TitulacaoCoordenadorCursoCertificacao.Mestrado
      ],
    texto: 'Mestrado'
  },
  {
    id:
      TitulacaoCoordenadorCursoCertificacao[
        TitulacaoCoordenadorCursoCertificacao.Doutorado
      ],
    texto: 'Doutorado'
  }
]
